angular.module('document')
    .component('documentPriorityLabel', {
        bindings: {
            priority: '<'
        },
        template: `
            <span ng-if="$ctrl.priority != null" class="label document-priority-{{$ctrl.priority}}">{{'document.priority.' + $ctrl.priority | translate}}</span>
        `
    })
